import React from "react";
import { motion } from "framer-motion";
import { CheckIcon } from "lucide-react";
import { CTAButton, TrustBadges } from "./ui";
import { heroBenefits, heroMockup } from "./data";
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-[#f4f9ff]" data-id="element-95" data-mp="9luxogngtxr3">
      <div className="pointer-events-none absolute -left-32 top-0 h-72 w-72 rounded-full bg-[#dbeaff] opacity-70 blur-3xl" data-id="element-96" data-mp="4m8nkg2xoxmi" />
      <div className="pointer-events-none absolute -right-28 bottom-0 h-72 w-72 rounded-full bg-[#e0f2e7] opacity-70 blur-3xl" data-id="element-97" data-mp="128fs5pz8mpyv" />

      <div className="relative mx-auto grid max-w-6xl items-center gap-8 px-4 pb-10 pt-8 sm:px-8 sm:pb-20 sm:pt-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14" data-id="element-98" data-mp="xb5qnbykqnuo">
        <div className="text-center lg:text-left" data-id="element-99" data-mp="nczqozwbvrsg">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4
        }} className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-[var(--accent)]" data-id="element-100" data-mp="neaz5d0pxnpw">
            Pequeños Pasos, Grandes Logros™
          </motion.p>

          <motion.h1 initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-3 font-serif-display text-[2.05rem] font-semibold leading-[1.05] tracking-[-0.03em] text-[var(--ink)] sm:text-[3.2rem] lg:text-[3.4rem]" data-id="element-101" data-mp="3o7c05xxxspgm">
            <span className="text-[var(--accent)]" data-id="element-102" data-mp="30fy9rxjcj3ya">Comprendé mejor</span> lo que pasa. Y descubrí{" "}
            <span className="text-[var(--accent)]" data-id="element-103" data-mp="35audhuxy3fr8">nuevas formas de acompañar</span>.
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.12
        }} className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-[var(--muted)] sm:text-lg lg:mx-0" data-id="element-104" data-mp="2qi0mbc9b9b6q">
            Una colección práctica de 6 guías para sumar herramientas en rutinas, atención,
            emociones, aprendizaje, comunicación y esos momentos cotidianos en los que no
            siempre sabés qué hacer.
          </motion.p>

          <motion.ul initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.18
        }} className="mx-auto mt-5 grid max-w-md grid-cols-2 gap-x-4 gap-y-2 text-left sm:mt-7 lg:mx-0 lg:max-w-lg" data-id="element-105" data-mp="iboywmxo6qvf">
            {heroBenefits.map(b => <li key={b} className="flex items-start gap-2" data-id="element-106" data-mp="163436l90bi9b">
                <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-[var(--accent-green)] text-white" data-id="element-107" data-mp="1126owjr4b8d3">
                  <CheckIcon className="h-2.5 w-2.5" aria-hidden data-id="element-108" data-mp="x0l2o7sp1hq8" />
                </span>
                <span className="text-xs font-semibold leading-snug text-[var(--ink)] sm:text-sm" data-id="element-109" data-mp="3ltqclcptivti">
                  {b}
                </span>
              </li>)}
          </motion.ul>

          {/* Mockup appears between copy and CTA on mobile only. */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative mx-auto mt-6 w-full max-w-[260px] lg:hidden" data-id="element-110" data-mp="21aekbl6vatcq">
            <div className="absolute inset-x-6 bottom-2 h-10 rounded-full bg-[#296fe8]/20 blur-2xl" data-id="element-111" data-mp="2g02iwennzdwr" />
            <img src={heroMockup} alt="Colección Pequeños Pasos, Grandes Logros: 6 guías digitales" className="relative w-full rounded-2xl border-4 border-white object-contain shadow-[0_22px_50px_-24px_rgba(23,50,77,0.55)]" loading="eager" data-id="element-112" data-mp="2kyndnyk5d5dt" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.26
        }} className="mt-6 sm:mt-8" data-id="element-113" data-mp="unrd141n9xwk">
            <CTAButton data-id="element-114" data-mp="49t5s073b8vi">Quiero conocer las guías</CTAButton>
            <TrustBadges className="mt-4 lg:justify-start" data-id="element-115" data-mp="3vi714skacoxd" />
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96,
        y: 14
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.15,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative hidden lg:block" data-id="element-116" data-mp="ea3gne5nk47i">
          <div className="absolute inset-x-16 bottom-6 h-16 rounded-full bg-[#296fe8]/20 blur-3xl" data-id="element-117" data-mp="3hnxt0gwf6eqk" />
          <img src={heroMockup} alt="Colección Pequeños Pasos, Grandes Logros: 6 guías digitales" className="relative mx-auto w-full max-w-[460px] rounded-[1.75rem] border-[6px] border-white object-contain shadow-[0_36px_70px_-30px_rgba(23,50,77,0.6)]" loading="eager" data-id="element-118" data-mp="3cpctykswm13p" />
        </motion.div>
      </div>
    </header>;
}